const customDropdown = document.querySelectorAll('.custom-dropdown__select');

// Plugin link - https://bluzky.github.io/nice-select2/

customDropdown.forEach((el) => {
  NiceSelect.bind(el);
});
